import * as React from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Close from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'

type Props = {
  onClose: () => void
}

export function LeadAssignmentRuleInfoHeader(props: Props) {
  const { onClose } = props
  const theme = useTheme()
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="h6" color={theme.palette.text.primary}>
        Assignment Rule Details
      </Typography>
      <IconButton
        onClick={onClose}
        data-test-id="lead-assignment-rule-info-header-close-button"
      >
        <Close />
      </IconButton>
    </Stack>
  )
}
